import type { MouseEvent } from "react";
import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useSearchParams } from "react-router-dom";
import { CreateButton, usePermissions } from "react-admin";
import type { PermissionRecord } from "@/types/permissions";
import { hasPermission } from "@/utils/permission-utils";

/** Mirrors hall bookings `BookingActions` + `ViewToggle` structure. */
function RazaEventsActions({ permissions }: { permissions: unknown }) {
  return (
    <>
      {hasPermission(permissions as PermissionRecord | null | undefined, "razaEvents.create") && (
        <CreateButton resource="raza-events" />
      )}
    </>
  );
}

type RazaEventsViewToggleProps = {
  hideCreateButton?: boolean;
};

export function RazaEventsViewToggle({ hideCreateButton }: RazaEventsViewToggleProps) {
  const { permissions } = usePermissions();
  const [searchParams, setSearchParams] = useSearchParams();
  const viewParam = searchParams.get("tab") || "CALENDAR";

  const handleChange = (_e: MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("tab", newValue);
      setSearchParams(newParams);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexShrink: 0,
        minWidth: "fit-content",
      }}
    >
      {!hideCreateButton && <RazaEventsActions permissions={permissions} />}
      <ToggleButtonGroup
        value={viewParam}
        exclusive
        onChange={handleChange}
        sx={{ ml: hideCreateButton ? 0 : 1, display: "flex", alignItems: "center" }}
        size="small"
      >
        <ToggleButton value="CALENDAR" aria-label="calendar" sx={{ height: 40 }}>
          <CalendarMonthIcon />
        </ToggleButton>
        <ToggleButton value="LIST" aria-label="list" sx={{ height: 40 }}>
          <ViewListIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default RazaEventsViewToggle;
